export default {
  ExerciseRefer: {
    Grade: 'Khối',
    Subject: 'Môn học',
    Topic: 'Chủ để',
    AnswerExercise: 'Kết quả bài đã làm',
    IsFree: 'Miễn phí',
    UseNow: 'Sử dụng ngay',
    UsedStartTime: 'Bắt đầu sử dụng:  09/09/2021',
    RelatedExercise: 'Học liệu liên quan',
    HocMai: 'Hệ thống giáo dục HOCMAI'
  }
}
